module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_faq_anchor-c1c7110811adbf05eefea3982b000692.png";